<template>
  <div class='d-flex align-center'>
    <button
      class="menu-item"
      :class="{ 'is-active': isActive ? isActive(): null }"
      @click="action"
      :title="title"
    >
      <v-icon v-if='icon' class='menu-icon' :class="{ 'is-active': isActive ? isActive(): null }">{{icon}}</v-icon>
    </button>
    <div v-if='highlightingText' class='caption px-1' :style='"background-color: " + highlightingColor + ";"'>{{ highlightingText }}</div>
  </div>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: false,
    },
    iconText: {
      type: String,
      required: false,
      default: ""
    },
    title: {
      type: String,
      required: true,
    },
    action: {
      type: Function,
      required: true,
    },
    isActive: {
      type: Function,
      default: null,
    },
    highlightingText: {
      type: String,
      required: false,
      default: ""
    },
    highlightingColor: {
      type: String,
      required: false,
      default: ""
    }
  },
}
</script>

<style lang="scss" scoped>
.menu-item {
  width: 1.75rem;
  height: 1.75rem;
  color: #0D0D0D;
  border: none;
  background-color: transparent;
  border-radius: 0.4rem;
  padding: 0.1rem;
  margin-right: 0.25rem;

  &.is-active,
  &:hover {
    color: #FFF;
    background-color: #2D2D2D;
  }
}

.menu-icon {
  color: #0D0D0D;

  &.is-active,
  &:hover {
    color: #FFF;
  }
}

</style>